<template lang="html">

<div class="subComponent">

  <el-dialog
    title="新增材料"
    :visible.sync="openstate"
    width="600px"
    @open="openHandle"
    @closed="handleClose">

    <div class="cbody">
        <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">
            <div class="text-block clearfix">
                <div class="bName">名称</div>
                <div class="bContent">
                     <el-form-item prop="name">
                         <el-input size="medium" v-model="params.name" placeholder="请输入内容"></el-input>
                     </el-form-item>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">来源</div>
                <div class="bContent">
                     <el-form-item prop="source">
                        <el-input size="medium" v-model="params.source" placeholder="请输入内容"></el-input>
                     </el-form-item>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">其他要求</div>
                <div class="bContent">
                     <el-input type="textarea" size="medium" v-model="params.otherRequirements" placeholder="请输入其他要求"></el-input>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">原件份数</div>
                <div class="bContent">
                    <el-form-item prop="originalNumber">
                       <el-input-number size="medium" v-model="params.originalNumber"></el-input-number>
                    </el-form-item>

                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">复印件份数</div>
                <div class="bContent">
                      <el-form-item prop="photocopyNumber">
                         <el-input-number size="medium" v-model="params.photocopyNumber"></el-input-number>
                      </el-form-item>
                </div>
            </div>
        </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
        <el-button @click="openstate = false" size="small">取 消</el-button>
        <el-button @click="goSubAdd" size="small" type="primary">确 定</el-button>
    </div>
 </el-dialog>

</div>

</template>

<script>
export default {

    data(){
        return{
            type:'add',
            inx:'',
            openstate:false,
            params:{
                name:'',
                source:'',
                otherRequirements:'',
                originalNumber:'',
                photocopyNumber:''
            },
            rules:{
                name:[{
                   required: true,
                   trigger: 'blur'
                }],
                source:[{
                   required: true,
                   trigger: 'blur'
                }],
                originalNumber:[{
                   required: true,
                   trigger: 'blur'
                }],
                photocopyNumber:[{
                   required: true,
                   trigger: 'blur'
                }],
            }
        }
    },

    methods:{
        goSubAdd:function(){
            var vues = this;
            vues.$refs.ruleForm.validate((valid) => {
                if(valid){
                   vues.$emit('goAdd',{
                       data:vues.params,
                       type:vues.type,
                       inx:vues.inx
                   });
                   this.openstate = false;
                }
            })
        },
        goEdit:function(e,inx){
            var vues = this;
            this.inx = inx;
            for(var key in e){
                vues.$set(this.params, key, e[key]);
            }
        },
        openHandle:function(){
            if(this.$refs.ruleForm){
                this.$refs.ruleForm.clearValidate();
            }
        },
        handleClose:function(){
            for(let key in this.params){
                this.params[key] = '';
                this.type = 'add';
                this.inx = '';
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.text-block{
      font-size: 14px;
      margin-right: 20px;
     .bName{
          width: 70px;
          padding-top: 8px;
          float: left;
          text-align: right;
     }
     .bContent{
          margin-left: 90px;
          position: relative;
          margin-bottom: 20px;
          .inpText{
              width: 270px;
          }
          .tips{
              font-size: 12px;
              margin-left: 6px;
              color: #999999;
          }

     }

}

.text-block:last-child .bContent{
    margin-bottom: 0px;
}

.cbody{
    // padding: 0px;
}

</style>

<style lang="css">

.el-dialog__body{
    padding: 12px 20px !important;
}

.el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// newMet.vue?5c1784f8